import { Form, InputNumber } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Cost } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function CostEditPage(props: { cost?: Cost; onSaved: (cost?: Cost) => void; onCancel: () => void }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const formValues: any = {
    ...props.cost,
  };

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.cost) {
      apiClient
        .post('costs', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`costs/${props.cost?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form form={form} layout="vertical" name="basic" onFinish={onFinish} initialValues={formValues}>
      <Form.Item
        label="En düşük"
        name="lowest"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            message: 'En düşük değer en yüksek değerden küçük olmalıdır',
            validator: (_, value) => {
              const highestValue = form.getFieldValue('highest');
              if (!highestValue) {
                return Promise.resolve();
              }
              if (value <= parseFloat(highestValue)) {
                return Promise.resolve();
              } else {
                return Promise.reject();
              }
            },
          },
        ]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item
        label="En yüksek"
        name="highest"
        rules={[
          {
            message: 'En yüksek değer en küçük değerden büyük olmalıdır',
            validator: (_, value) => {
              const lowestValue = form.getFieldValue('lowest');
              if (!value) {
                return Promise.resolve();
              }
              if (parseFloat(lowestValue) <= value) {
                return Promise.resolve('lowest');
              } else {
                return Promise.reject();
              }
            },
          },
        ]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item label="Öncelik puanı" name="priorityScore" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
